// HyperlinkEditor.tsx
import React from 'react';
import { FormControl } from '@common/components/form-control';

export interface HyperlinkEditorProps {
  value: string;
  onChange: (value: string) => void;
  onUpload: () => void;
  autoFocus?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onSubmit?: (value: string) => void;
}

export const HyperlinkEditor: React.FC<HyperlinkEditorProps> = ({
  value,
  onChange,
  onUpload,
  autoFocus = false,
  className = "",
  style = {},
  onSubmit,
}) => {
  return (
    <div 
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        gap: 4,
        width: '100%',
        minHeight: 34,
        height: 34,
        // backgroundColor: 'white',
        border: '1px solid #cfcfcf',
        borderRadius: 4,
        cursor: 'default',
        boxSizing: 'border-box',
        ...style
      }}
      className={className}
      onMouseDown={(e) => {
        // prevent cell selection on click
        e.stopPropagation();
      }}
    >
      {/* Left: hyperlink icon */}
      <img
        src="gif/hyperlink.gif"
        alt="Link"
        style={{ width: 16, height: 16, flexShrink: 0 }}
        onMouseDown={(e) => e.preventDefault()}
      />
      
      {/* Value input area */}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            onSubmit?.(value);
          }
          // prevent spreadsheet global handlers from stealing focus/keys
          e.stopPropagation();
        }}
        style={{
          flex: 1,
          minWidth: 0,
          width: "100%",
          border: "none",
          outline: "none",
          padding: "0 6px",
          fontSize: "inherit",
          backgroundColor: "transparent",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      />

      {/* Right: upload icon button */}
      <button
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onUpload();
        }}
        title="Upload Document"
        style={{
          width: 22,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ebebeb",
          border: "1px solid #bbb",
          padding: 0,
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        <img src="gif/upload.gif" alt="Upload" style={{ width: 12, height: 12 }} />
      </button>
    </div>
  );
};